module.exports = __webpack_public_path__ + "img/kjjh_gallery11.ca7a16c3.jpg";